import { getSiteInfo } from "./commonUtil";

function makeRequest({ url = "", method = "GET", body, optionalHeaders = {} }) {
  if (!url) {
    throw new Error("Invalid Url");
  }
  const payload = {
    method,
    headers: {
      "Content-Type": "application/json",
      ...optionalHeaders,
    },
    credentials: "same-origin",
  };

  if (body) {
    payload.body = JSON.stringify(body);
  }

  return window.fetch(url, payload);
}

export function makeIntegrationRequest({
  payload,
  successCallback = () => {},
  failureCallback = () => {},
}) {
  makeRequest({
    url: getSiteInfo().INTEGRATION_REQUEST_API,
    method: "POST",
    body: payload,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && data.success) {
        successCallback(data);
      } else {
        failureCallback(data);
      }
    })
    .catch(() => {
      failureCallback();
    });
}

export function makeLeadRegistrationRequest({
  payload,
  successCallback = () => {},
  failureCallback = () => {},
}) {
  makeRequest({
    url: getSiteInfo().LEAD_REGISTRATION_API,
    method: "POST",
    body: payload,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && data.status) {
        successCallback(data);
      } else {
        failureCallback(data);
      }
    })
    .catch(() => {
      failureCallback();
    });
}
